module.exports = __webpack_public_path__ + "static/logo-schoolab-5ace8a7f546545b7255d79f1189f329e.png";